var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLetterIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.5744 21.2148V47.8767C57.5744 49.291 57.0126 50.6473 56.0126 51.6473C55.0126 52.6473 53.6563 53.2091 52.242 53.2091H14.9154C13.5012 53.2091 12.1448 52.6473 11.1448 51.6473C10.1448 50.6473 9.58301 49.291 9.58301 47.8767V21.2148",
    stroke: "black",
    strokeWidth: 1.925,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.58301 21.2149L33.5787 37.212L57.5744 21.2149L33.5787 5.21777L9.58301 21.2149Z",
    stroke: "black",
    strokeWidth: 1.925,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.58301 47.877L25.5801 31.8799",
    stroke: "black",
    strokeWidth: 1.925,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5771 31.8799L57.5743 47.877",
    stroke: "black",
    strokeWidth: 1.925,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5605 30.7487L33.5899 41.6139L22.6194 30.7487C21.8958 30.0445 21.3258 29.1982 20.9453 28.2629C20.5649 27.3277 20.3822 26.3238 20.4088 25.3145C20.4354 24.3052 20.6707 23.3123 21.0998 22.3984C21.529 21.4844 22.1427 20.6693 22.9024 20.0042C23.6621 19.3391 24.5512 18.8386 25.5139 18.534C26.4765 18.2295 27.4918 18.1275 28.4957 18.2346C29.4997 18.3417 30.4706 18.6555 31.3474 19.1563C32.2241 19.6571 32.9876 20.3339 33.5899 21.1443C34.1948 20.3398 34.9593 19.6689 35.8354 19.1734C36.7115 18.678 37.6805 18.3687 38.6816 18.2649C39.6828 18.1612 40.6946 18.2652 41.6537 18.5705C42.6128 18.8757 43.4986 19.3757 44.2556 20.039C45.0126 20.7023 45.6245 21.5148 46.0531 22.4255C46.4817 23.3362 46.7176 24.3256 46.7463 25.3317C46.7749 26.3378 46.5955 27.339 46.2194 28.2726C45.8433 29.2062 45.2786 30.0521 44.5605 30.7574",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5605 30.7487L33.5899 41.6139L22.6194 30.7487C21.8958 30.0445 21.3258 29.1982 20.9453 28.2629C20.5649 27.3277 20.3822 26.3238 20.4088 25.3145C20.4354 24.3052 20.6707 23.3123 21.0998 22.3984C21.529 21.4844 22.1427 20.6693 22.9024 20.0042C23.6621 19.3391 24.5512 18.8386 25.5139 18.534C26.4765 18.2295 27.4918 18.1275 28.4957 18.2346C29.4997 18.3417 30.4706 18.6555 31.3474 19.1563C32.2241 19.6571 32.9876 20.3339 33.5899 21.1443C34.1948 20.3398 34.9593 19.6689 35.8354 19.1734C36.7115 18.678 37.6805 18.3687 38.6816 18.2649C39.6828 18.1612 40.6946 18.2652 41.6537 18.5705C42.6128 18.8757 43.4986 19.3757 44.2556 20.039C45.0126 20.7023 45.6245 21.5148 46.0531 22.4255C46.4817 23.3362 46.7176 24.3256 46.7463 25.3317C46.7749 26.3378 46.5955 27.339 46.2194 28.2726C45.8433 29.2062 45.2786 30.0521 44.5605 30.7574",
    stroke: "black",
    strokeWidth: 2.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetterIcon);
export default __webpack_public_path__ + "static/media/letterIcon.ebfe46ba4e8fe697047d8a37bf509909.svg";
export { ForwardRef as ReactComponent };